module.exports = __webpack_public_path__ + "static/media/Up.2d6dde8d.webp";